import { useTranslate } from '@refinedev/core';
import { TextField } from '@refinedev/antd';
import { Typography } from 'antd';
import type { ContentAudiobookOut } from '@/api/generated/schemas';

const { Title } = Typography;

export const ProductAudiobookTab = ({
  audiobook,
}: {
  audiobook: ContentAudiobookOut | null | undefined;
}) => {
  const t = useTranslate();

  if (!audiobook) {
    return (
      <Typography.Text type="secondary">
        {t('content_catalog.products.audiobook.not_available')}
      </Typography.Text>
    );
  }

  return (
    <>
      <Title level={4}>{t('content_catalog.products.tabs.audiobook')}</Title>

      {audiobook.id != null && (
        <>
          <Title level={5}>{t('base.fields.id')}</Title>
          <TextField value={audiobook.id} />
        </>
      )}

      {audiobook.duration != null && (
        <>
          <Title level={5}>
            {t('content_catalog.products.audiobook.fields.duration')}
          </Title>
          <TextField
            value={`${Math.floor(audiobook.duration / 3600)}h ${Math.floor((audiobook.duration % 3600) / 60)}m`}
          />
        </>
      )}
    </>
  );
};
